var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresential({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.047,
    height: 14.046,
    viewBox: "0 0 14.047 14.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1049",
    "data-name": "Grupo 1049",
    transform: "translate(17829.977 5812.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-17830.74 -5813.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2116467169744",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_429",
    "data-name": "Trazado 429",
    d: "M72.233,65.21a7.023,7.023,0,1,1-7.023,7.023A7.023,7.023,0,0,1,72.233,65.21Z",
    transform: "translate(-64.446 -64.446)",
    fill: "#4a8cff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "map-pin_4_",
    "data-name": "map-pin (4)",
    transform: "translate(-17828.539 -5810.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusi\\xF3n_1",
    "data-name": "Exclusi\\xF3n 1",
    d: "M8915.406,1477.273h0c-.906-.639-3.865-2.915-3.865-5.408a3.873,3.873,0,0,1,7.736,0c0,2.492-2.961,4.77-3.867,5.408Zm0-7.248a1.842,1.842,0,1,0,1.936,1.839A1.889,1.889,0,0,0,8915.406,1470.025Z",
    transform: "translate(-8909.821 -1468.47)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresential);
export default __webpack_public_path__ + "static/media/presential.e77297ab71851cbcaab5cd00b3c828e8.svg";
export { ForwardRef as ReactComponent };